// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2579) return "static/chunks/2579-053d7eb9eabf26ff.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"65":"2f06ba26ca511ac1","1814":"9549e33d1661a6b0","4246":"f60d3940c51c9e97","4438":"d510c24fbfddf2c0"}[chunkId] + ".js";
};